import createApi from './api';

const adminApi = createApi({
  baseUrl: `/admin`,
  headers: {
    'Content-Type': 'application/json'
  },
});

const deviceApi = createApi({
  baseUrl: `/device`,
  headers: {
    'Content-Type': 'application/json',
    "x-api-key": "devxcfsdfgvS234DFGHREYHFcxsad34tfdgvf3454dfgd",
  },
});

export default class FeatureTogglesService {
  async getFeatureFlags(hwId) {
    if (hwId) {
      return deviceApi.post('config-ui', { hw_id: hwId });
    } else {
      return adminApi.get('config/ui');
    }
  }
}
